import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#121212]/80 backdrop-blur-md py-4 border-b border-white/10' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-109">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-110">
        <a href="#" className="block" data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/3ADQKp1DHnDUdGH3xP27Pb/Onyx__Steel_Logo-Sin_fondo.png" alt="Onyx & Steel Logo" className="h-24 md:h-28 object-contain" data-id="element-112" />
        </a>
        <nav className="hidden md:flex gap-8 text-xs tracking-[0.2em] uppercase font-medium text-white/80" data-id="element-113">
          <a href="#services" className="hover:text-white hover:text-shadow-glow transition-all" data-id="element-114">
            Services
          </a>
          <a href="#standard" className="hover:text-white hover:text-shadow-glow transition-all" data-id="element-115">
            The Standard
          </a>
          <a href="#about" className="hover:text-white hover:text-shadow-glow transition-all" data-id="element-116">
            About
          </a>
          <a href="#contact" className="hover:text-white hover:text-shadow-glow transition-all" data-id="element-117">
            Contact
          </a>
        </nav>
      </div>
    </motion.header>;
}